import { render, staticRenderFns } from "./IndecisiveButton.vue?vue&type=template&id=6ddbeb49&scoped=true&"
import script from "./IndecisiveButton.vue?vue&type=script&lang=js&"
export * from "./IndecisiveButton.vue?vue&type=script&lang=js&"
import style0 from "./IndecisiveButton.vue?vue&type=style&index=0&id=6ddbeb49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddbeb49",
  null
  
)

export default component.exports